import { GraphNodeType } from "@custom-types/graphs"
import { NodeType } from "@features/builder/graph/types"

// Worker-safe: no DOM or React imports. Keep it that way.

const NODE_TYPE_MAP = new Map<GraphNodeType | NodeType, string>([
  [GraphNodeType.CONTINOUS, "continuous"],
  [GraphNodeType.MIXTURE, "mixture"],
  [GraphNodeType.DISCRETE, "discrete"],
  [GraphNodeType.CATEGORICAL, "categorical"],
  [GraphNodeType.DETERMINISTIC, "deterministic"],
  [GraphNodeType.TABLE, "table"],
  [GraphNodeType.GROUP, "group"],
  [GraphNodeType.LAG, "lag"],
  [GraphNodeType.FORECAST, "forecast"],
  [GraphNodeType.SCENARIO, "scenario"],
  [NodeType.Empty, "empty"],
  [NodeType.Group, "group"],
  [NodeType.Categorical, "categorical"],
  [NodeType.Continuous, "continuous"],
  [NodeType.Deterministic, "deterministic"],
  [NodeType.Discrete, "discrete"],
  [NodeType.Forecast, "forecast"],
  [NodeType.Lag, "lag"],
  [NodeType.Mixture, "mixture"],
  [NodeType.Table, "table"],
  [NodeType.ScenarioTable, "advanced scenario table"],
  [NodeType.ForecastTable, "advanced forecast table"],
  [NodeType.Scenario, "scenario"],
])

/**
 * Compares node types from two different sources (GraphNodeType from API and NodeType from UI).
 * Both enums represent the same node types but come from different parts of the system.
 */
export const isNodeTypeEqual = (graphNodeType?: GraphNodeType, nodeType?: NodeType): boolean => {
  if (!graphNodeType || !nodeType) return false
  return NODE_TYPE_MAP.get(graphNodeType) === NODE_TYPE_MAP.get(nodeType)
}
